<app-user-header class="d-md-none"></app-user-header> 
<div class="row m-0 h-100 row-container"> 



  <div class="col-formed-side pe-0 ps-0 section-side-nav h-100 d-none d-md-block">
    <app-sidebar></app-sidebar>
  </div>
  <div class="col-formed-main big-area wrap-container ps-2 pe-2">

<div class="wrapperi pb-4 ">
  
    <div class="col-12 row ms-0 me-0 mt-3">
      <div class="col-12 mt-4 col-md-12 input-cover">
        <div class="col-12">
            <div class="d-flex mb-4">
                <div class="d-flex first-tag pointer" routerLink="/{{businessID}}/marketplaces/marketplace">
                    <div [ngClass]="!companyID ? 'active-tag' : 'non-active-tag'">
                        <p class="mb-0">Kaikki ilmoitukset</p>
                </div>
                </div>
                <div class="d-flex pointer" routerLink="/{{businessID}}/marketplaces/marketplace/{{businessID}}">
                    <div [ngClass]="companyID ? 'active-tag' : 'non-active-tag'">
                        <p class="mb-0">Omat ilmoitukset</p>
                </div>
            </div>
            </div>
        </div>
        <div class="bg-f-w p-4">
            <div class="d-flex justify-content-between">
                <p class="formed-sub-title">
                    <span *ngIf="companyID">Omat ilmoitukset ({{openings.length}})</span>
                    <span *ngIf="!companyID">Tuloksia ({{openings.length}})</span>
                </p>
                <button class="btn btn-formed-main-blue" routerLink="/{{businessID}}/marketplaces/add-marketplace">Lisää ilmoitus</button>
            </div>
            <div class="row mt-4" *ngIf="openings && openings.length > 0; else no_openings">
                <div class=" mt-3 col-4" *ngFor="let opening of openings">
                    <div class="card h-100">
                        <div class="card-body h-100">
                            <div class="col-12">
                                <div class="col-12 d-flex justify-content-between">
                                    <div class="first-section d-flex">
                                        <div class="img-container me-4 mt-2">
                                            <div class="" *ngIf="opening && opening.logo; else no_logo">
    
                                                <img src="{{opening.logo}}" class="rounded-circle" width="50" height="50" alt="">  
            
                                            </div>
                                            <ng-template #no_logo>
                                                <img src="../../assets/images/formed_blur.jpg" class="rounded-circle" width="50" height="50" alt="">  
                                            </ng-template>
                                        </div>
  
                                        <div class="">
                                            <p class="mb-1 lighttextblue16">{{opening.businessName}}</p>
                                            <p class="mb-0 semibolddeepbluetext16"> {{opening.title}}</p>
                                            <div class="pb-4">
                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="bg-f-w p-3">
                                        <p class="normaltextblue16 mb-0">{{opening.description | truncate : 100}}</p>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="mt-4">
                                        <div class="mt-4 text-center d-flex justify-content-center col-12" *ngIf="companyID">
                                            <button type="button" routerLink="/{{businessID}}/marketplaces/marketplace/single-marketplace/own/{{opening._id}}" class="btn btn-formed-main-blue w-100">Tiedot</button>
                                        </div>
                                        <div class="mt-4 text-center d-flex justify-content-center col-12" *ngIf="!companyID">
                                            <button type="button" routerLink="/{{businessID}}/marketplaces/marketplace/single-marketplace/other/{{opening._id}}" class="btn btn-formed-main-blue w-100">Lue lisää</button>
                                        </div>
                                    </div>
                                </div>

    
                            </div>
                        </div>
                    </div>
    
                </div>
                </div>
                <ng-template #no_openings>
                    <div class="col-12 d-flex justify-content-center">
                        <div class="alert alert-warning">
                            <p class="text-center ps-4 pe-4">Et ole vielä tehnyt ilmoitusta lisää se tästä</p>
                            <div class="d-flex justify-content-center">
                                <button class="btn btn-formed-main-green" routerLink="/{{businessID}}/marketplaces/add-marketplace">Lisää markkinailmoitus</button>
    
                            </div>
                        </div>
                    </div>
                </ng-template>
        </div>
        </div>
  </div>
</div>
  </div>

    </div>